module.exports = __webpack_public_path__ + "img/terminal.ad80a252.png";